import React, { FC } from "react";
import cn from "classnames";
import logoImg from "src/assets/images/logo.png";
import { PATHNAMES } from "src/constants/routes";
import { Link } from "../Link";

const ALT_TEXT_LOGO_IMG = "Universal Business Resource";

interface Props {
  linkHref?: string;
  className?: string;
}

export const Logo: FC<Props> = ({ linkHref, className }) => (
  <div>
    <Link href={linkHref || PATHNAMES.HOME}>
      <img
        className={cn(
          "w-32 h-15 sm:w-46.25 sm:h-25 object-contain object-center",
          className
        )}
        src={logoImg}
        alt={ALT_TEXT_LOGO_IMG}
      />
    </Link>
  </div>
);
